<div
  class="row"
  style="padding-left: 15px;"
  *ngIf="hasEntitlements('CARDHOLDERS_OPEN_LOOP_HISTORY')"
>
  <div
    class="card-nc col-md-5"
    style="background-color: #ffffff; padding-bottom: 6px;margin-right: 30px;"
  >
    <div class="row">
      <div class="col-md-5">
        <span class="labelCommon">STRIP ACCOUNT</span><br />
        <span class="staticText1">{{ stripAccount?.account }}</span>
      </div>
      <div class="col-md-4" style="padding-right: 0; padding-left: 0;">
        <span class="labelCommon">VISA AVAILABLE BALANCE</span>
        <br />
        <span class="staticText1">
          <span class="dollerSymbolColor"> </span>
          <span *ngIf="visaBalance !== ''">
            {{ visaBalance | currency }}
          </span>
          <span *ngIf="visaBalance === ''">
            $
          </span>
        </span>
      </div>
    </div>
  </div>
</div>

<div
  class="card card-nc"
  style="background-color: rgba(65, 65, 65, 0.8);"
  *ngIf="hasEntitlements('CARDHOLDERS_OPEN_LOOP_HISTORY')"
>
  
  <div class="row" style="margin-left: 10px; margin-right: 10px;">
    <div class="table-responsive">
      <table class="table tableBackground tableRow table-bordered table-hover">
        <thead style="background-color: #3b74b0;">
          <tr>
            <th>TRANSACTION DATE</th>
            <th>POST DATE</th>
            <th>MERCHANT NAME/LOCATION</th>
            <th>DESCRIPTION</th>
            <th>
              AMOUNT&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </th>
          </tr>
        </thead>
        <tbody style="background-color: #ffffff;">
          <tr *ngIf="loading">
            <td colspan="7" style="text-align: center; height: 150px;">
              <i class="fa fa-spinner fa-2x fa-pulse"></i>
            </td>
          </tr>
          <tr *ngIf="transactions.length === 0 && !loading">
            <td colspan="7" style="text-align: center; height: 150px;">
              No account activity found.
            </td>
          </tr>
          <ng-container *ngFor="let transaction of pagedResults">
            <ng-container>
              <tr>
                <!--  td class="transactionHistText text-center col-md-2">{{transaction.date | date : 'mediumDate'}}</td  -->
                <td class="transactionHistText text-left col-2">
                  {{ transaction.date | date: 'MM/dd/yyyy HH:mm:ss' }}
                </td>
                <td class="transactionHistText text-left col-2">
                  {{ transaction.postDate | date: 'MM/dd/yyyy HH:mm:ss' }}
                </td>
                <!-- pattern="MM/dd/yyyy" -->
                <td class="transactionHistText text-left col-4">
                  {{ transaction.merchantName }}
                </td>
                <td class="transactionHistText text-left col-4">
                  {{ transaction.descr }}
                </td>
                <td
                  class="transactionHistText text-right col-4"
                  [ngClass]="{
                    'text-success': transaction.amount >= 0.0,
                    'text-fail': transaction.balance < 0.0
                  }"
                >
                  {{ transaction.amount | currency }}
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>

      <!-- <tr  ng-show=" totalItems > itemsPerPage "> -->
      <div style="margin: 10px;">
        <app-pagination
          *ngIf="transactions && transactions.length > itemsPerPage"
          (pageSet)="pageSet($event)"
          [totalItems]="transactions.length"
          [itemsPerPage]="itemsPerPage"
        >
        </app-pagination>
      </div>
    </div>
  </div>
</div>
